<template>
  <sa-page-layout :btnBackVisible="true" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading">
    <template slot="toolbar">
      <!-- <b-button class="my-2 my-sm-0" variant="outline-purple btn-toolbar sa-margin-left float-sm-left" @click="onClickApriDynamicForm"><i class="fas fa-exchange-alt"></i>Apri Dynamic Form </b-button> -->
    </template>
    <template slot="table-body">
      {{ jsonDataBuilderSend }} JSON DATA BUILDER SEND {{ jsonItemBuilder }} JSON ITEM BUILDER {{ jsonFormBuilder }} jsonFormBuilder
      <b-tabs content-class="mt-3" card>
        <b-tab title="Visualizza">
          <label for="">Seleziona Form</label>
          <b-row>
            <b-col>
              <b-form-select v-model="jsonFormSelected" @change="onChangeFormSelected" :options="listaForm" :value="null" value-field="id" text-field="titolo">
                <template #first>
                  <b-form-select-option :value="null" disabled> - Seleziona - </b-form-select-option>
                </template>
              </b-form-select>
            </b-col>
            <b-col>
              <b-form-checkbox v-model="isView" name="check-button" switch>
                <h5 class="sa-text-left domicilio-residenza-checkbox">VIEW</h5>
              </b-form-checkbox>
            </b-col>
          </b-row>

          <label>Form scelto {{ jsonData.titolo }} modalita {{ jsonData.titolo ? (isView ? "View" : "Edit") : "-" }}</label>
          <div class="ft-scroll">
            <dynamic-form ref="cmpDynamicForm" :jsonData="jsonData" :isView="isView"></dynamic-form>
          </div>
        </b-tab>
        <b-tab title="Crea Form" active>
          <b-tabs content-class="mt-3" card>
            <b-tab title="Form Db Info">
              <b-row style="padding: 2px">
                <b-col cols="3">
                  <label>Nome Form</label>
                  <b-form-input v-model="jsonDataBuilderSend.name"></b-form-input>
                </b-col>
                <b-col cols="3">
                  <label>Titolo Form</label>
                  <b-form-input v-model="jsonDataBuilderSend.titolo"></b-form-input>
                </b-col>
                <b-col cols="3">
                  <label>Path Module</label>
                  <b-form-input v-model="jsonDataBuilderSend.pathModule"></b-form-input>
                </b-col>
                <b-col cols="3">
                  <label>Sezione permessi DB</label>
                  <b-form-select v-model="jsonDataBuilderSend.sezione" :options="sezioni">
                    <template #first>
                      <b-form-select-option :value="null" disabled> - Seleziona - </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Tipologia">
              <b-row style="padding: 2px">
                <b-col cols="4">
                  <label>Label</label>
                  <b-form-input v-model="jsonItemBuilder.label"></b-form-input>
                </b-col>
                <b-col cols="4">
                  <label>Model-Name</label>
                  <b-form-input v-model="jsonItemBuilder.modelName"></b-form-input>
                </b-col>
                <b-col cols="4">
                  <label>Tipologia</label>
                  <b-form-select v-model="jsonItemBuilder.type" :options="tipologie" :value="null" value-field="value" text-field="text">
                    <template #first>
                      <b-form-select-option :value="null" disabled> - Seleziona - </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row style="padding: 2px" v-if="jsonItemBuilder.type == 'select'">
                <b-col cols="6">
                  <label>Scegli modalità di carimento dati</label>
                  <b-button @click="isDataOptionApi = false" variant="danger">Api</b-button>
                  <b-button @click="isDataOptionApi = true" variant="danger">Array Caricato</b-button>
                </b-col>

                <b-col v-if="isDataOptionApi" cols="6">
                  <b-card class="sa-card" header="Json Creato" header-tag="header" footer-tag="footer" title="" style="max-height: 100px; overflow-y: scroll">
                    <b-card-text>
                      <b-row>
                        <b-col>
                          <label>Value</label>
                          <b-input v-model="dataOption.value"> </b-input>
                        </b-col>
                        <b-col>
                          <label>Text</label>
                          <b-input v-model="dataOption.text"> </b-input>
                        </b-col>
                        <b-col> <b-button @click="aggiungiOpzione()" variant="primary">aggiungi</b-button></b-col>
                      </b-row>
                    </b-card-text>
                    <b-card-text>
                      <b-table sticky-header ref="tblDataOptions" stacked="xl" striped hover itemscope :items="jsonItemBuilder.select.dataOptions" :fields="fields" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                          {{ row.index }}
                        </template>
                        <template #cell(actions)="row">
                          <b-button size="sm" class="mr-1 ml-1 no-text" variant="outline-danger" @click="onClickDeleteOption(row)" title="Elimina">
                            <font-awesome-icon icon="trash" />
                          </b-button>
                        </template>
                      </b-table>
                    </b-card-text>
                  </b-card>
                </b-col>
                <b-col v-else cols="6">
                  <b-input value="TODO"> </b-input>
                </b-col>
              </b-row>
              <b-row style="padding: 2px" v-if="jsonItemBuilder.type == 'checkbox'">
                <b-col cols="3">
                  <label>Valore Check</label>
                  <b-input type="number" v-model="jsonItemBuilder.checkbox.checkedValue"> </b-input>
                </b-col>
                <b-col cols="3">
                  <label>Testo Check</label>
                  <b-input type="text" v-model="jsonItemBuilder.checkbox.checkedText"> </b-input>
                </b-col>
                <b-col cols="3">
                  <label>Valore unCheck</label>
                  <b-input type="number" v-model="jsonItemBuilder.checkbox.notCheckedValue"> </b-input>
                </b-col>
                <b-col cols="3">
                  <label>Testo unCheck</label>
                  <b-input type="text" v-model="jsonItemBuilder.checkbox.notCheckedText"> </b-input>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Sezione">
              <b-row style="padding: 2px">
                <b-col cols="4">
                  <label>inserisci sezione pagina (nome sezione e label sezione)</label>
                  <b-input type="text" v-model="sezioneBuilder.sezione"> </b-input>
                  <b-button size="sm" v-b-tooltip.hover title="Aggiungi" variant="outline-info" @click="onClickAggiungiSezione()">
                    <font-awesome-icon icon="plus" />
                  </b-button>
                </b-col>
                <b-col cols="4">
                  <label>Sezione Label</label>
                  <b-input type="text" v-model="sezioneBuilder.titolo"> </b-input>
                </b-col>
                <b-col cols="4">
                  <label>Seleziona Sezione Pagina FE</label>
                  <b-form-select @change="onChangeSezionePagina" v-model="jsonItemBuilder.sezione" value-field="sezione" text-field="sezione" :options="sezioniPagina">
                    <template #first>
                      <b-form-select-option :value="null" disabled> - Seleziona - </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Formattazione">
              <b-row style="padding: 2px">
                <b-col cols="2">
                  <label>Cols</label>
                  <b-input :max="12" :min="1" type="number" v-model="jsonItemBuilder.cols"> </b-input>
                </b-col>
                <b-col cols="2">
                  <label>XS</label>
                  <b-input :max="12" :min="1" type="number" v-model="jsonItemBuilder.xs"> </b-input>
                </b-col>
                <b-col cols="2">
                  <label>SM</label>
                  <b-input :max="12" :min="1" type="number" v-model="jsonItemBuilder.sm"> </b-input>
                </b-col>
                <b-col cols="2">
                  <label>MD</label>
                  <b-input :max="12" :min="1" type="number" v-model="jsonItemBuilder.md"> </b-input>
                </b-col>
                <b-col cols="2">
                  <label>LG</label>
                  <b-input :max="12" :min="1" type="number" v-model="jsonItemBuilder.lg"> </b-input>
                </b-col>
                <b-col cols="2">
                  <label>XL</label>
                  <b-input :max="12" :min="1" type="number" v-model="jsonItemBuilder.xl"> </b-input>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
          <b-row :style="{ marginTop: '12px' }">
            <b-col cols="6" class="text-left">
              <b-button @click="onClickResetJsonItemBuilder()" variant="danger">Reset Builder</b-button>
              <b-button @click="onClickAggiungiItem()" variant="primary">Aggiungi Item</b-button>
            </b-col>
            <b-col cols="6" class="text-right">
              <b-button @click="onClickResetForm()" variant="danger">Reset Form</b-button>
              <b-button @click="onClickConfermaForm()" variant="success">Conferma Form</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <label for="">Sezioni page Aggiunte</label>
              <b-row>
                <b-col cols="1" v-for="item in sezioniPagina" :key="item.modelName"> {{ item.sezione }} - </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <label for="">elementi aggiunti</label>
              <b-row>
                <b-col cols="1" v-for="item in jsonFormBuilder.jsonForm" :key="item.modelName">
                  <div class="text-center">
                    <b-button variant="primary" @click="onClickDeleteItemJsonForm(item.modelName)"> {{ item.modelName }} <b-badge variant="light">X</b-badge> </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col style="height: 450px; overflow-y: scroll">
              <h4>Preview</h4>
              <div v-if="showAnteprima" style="border: 1px solid black; max-height: fit-content">
                <dynamic-form ref="cmpDynamicFormPreview" :jsonData="jsonFormBuilder" :isView="isView"></dynamic-form>
              </div>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </template>
  </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import DynamicForm from "../../utility/components/DynamicForm.vue";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
  components: { SaPageLayout, DynamicForm },
  mixins: [UtilityMixin],
  data() {
    return {
      showAnteprima: true,
      pathDynamicForm: "",
      sezioneadd: "",
      tipologie: ["span", "input", "datepicker", "select", "textarea", "checkbox", "calculate"],
      sezioneBuilder: {
        sezione: null,
        sezioneTitolo: null,
      },
      sezioniPagina: [{ sezione: "base", sezioneTitolo: "---" }],
      jsonItemBuilder: {
        ordering: 1,
        label: null,
        modelName: null,
        type: null,
        sezione: "base",
        sezioneTitolo: null,

        cols: 12,
        xs: 12,
        sm: 12,
        md: 12,
        lg: 12,
        xl: 12,
        formula: null, //SUM
        formulaResult: null, //model del campo calculate
        dataOptions: [],
        pathOption: "",
        text: "text",
        value: "value",
        checkbox: {
          checkedValue: null,
          notCheckedValue: null,
          checkedText: null,
          notCheckedText: null,
        },
      },
      dataOption: {},
      isDataOptionApi: false,
      jsonFormBuilder: {
        titolo: null,
        jsonForm: [],
      },
      linkedit: null,
      linkback: "",
      pathResource: "",
      showModalLoading: false,
      isView: false,
      listaForm: [],
      jsonFormSelected: null,
      sezioni: [],
      jsonDataBuilderSend: {
        name: null,
        titolo: null,
        jsonForm: "",
        pathModule: null,
        sezione: null,
        note: null,
      },
      jsonData: {
        name: null,
        titolo: null,
        jsonForm: [],
        note: null,
      },
      fields: [
        {
          label: "",
          key: "index",
          sortable: false,
          thStyle: "width: 2rem",
        },
        {
          label: "text",
          key: "text",
          sortable: false,
          thStyle: "width: 2rem",
        },
        {
          label: "value",
          key: "value",
          sortable: false,
          thStyle: "width: 2rem",
        },
        {
          label: "",
          key: "actions",
          sortable: false,
          thStyle: "width: 2rem",
        },
      ],
    };
  },
  mounted() {
    this.loadFormSchemas();
  },
  methods: {
    onClickDeleteItemJsonForm(name) {
      console.log();
      console.log();
      this.jsonFormBuilder.jsonForm = this.jsonFormBuilder.jsonForm.filter((form) => form.modelName !== name);
      this.setFormPreview();
    },
    aggiungiOpzione() {
      let me = this;
      //let obj = JSON.parse(JSON.stringify());
      me.jsonItemBuilder.select.dataOptions.push({
        text: me.dataOption.text,
        value: me.dataOption.value,
      });
    },
    onChangeSezionePagina(v) {
      let me = this;
      let sezione = me.sezioniPagina.filter((e) => e.sezione === v);
      me.jsonItemBuilder.sezione = sezione[0].sezione;
    },
    onClickAggiungiItem() {
      let obj = JSON.parse(JSON.stringify(this.jsonItemBuilder));

      this.jsonFormBuilder.jsonForm.push(obj);
      this.setFormPreview();
    },
    onClickResetForm() {
      this.jsonFormBuilder.jsonForm = [];
      this.setFormPreview();
    },
    onClickAggiungiSezione() {
      this.sezioniPagina.push(JSON.parse(JSON.stringify(this.sezioneBuilder)));
      this.sezioneBuilder = {
        sezione: null,
        sezioneTitolo: null,
      };
    },
    onClickResetJsonItemBuilder() {
      this.jsonItemBuilder = {
        label: null,
        modelName: null,
        type: null,
        sezione: "base",
        sezioneTitolo: null,
        cols: 12,
        xs: 12,
        sm: 12,
        md: 12,
        lg: 12,
        xl: 12,
        formula: null, //SUM
        formulaResult: null, //model del campo calculate
        dataOptions: [],
        pathOption: "",
        text: "text",
        value: "value",
        checkbox: {
          checkedValue: null,
          notCheckedValue: null,
          checkText: null,
          notCheckedText: null,
        },
      };
    },
    onClickDeleteOption(row) {
      let me = this;

      me.jsonItemBuilder.dataOptions.splice(row.index, 1);
    },
    setFormPreview() {
      this.$refs.cmpDynamicFormPreview.setForm({});
    },
    loadFormSchema() {
      let me = this;
      console.log("carico form data");
      UtilityMixin.methods.loadDataResources("/dynamicform/" + this.jsonFormSelected, null, me.callBackSuccess, me.callBackError);
    },
    onClickApriDynamicForm() {
      let me = this;
      me.$refs.mdlDynamicForm.show();
    },
    callBackSuccess(response) {
      let me = this;
      console.log("SUCCESS");
      console.log(response);
      me.jsonData = response.data.data;
      me.jsonData.jsonForm = JSON.parse(response.data.data.jsonForm);
    },
    callBackError(error) {
      console.log("errorr");
      console.log(error);
    },
    loadFormSchemas() {
      let me = this;
      console.log("carico forms data");
      UtilityMixin.methods.loadDataResources("/dynamicform", null, me.callBackSuccessList, me.callBackErrorList);
    },
    callBackSuccessList(response) {
      let me = this;
      console.log(response);
      me.listaForm = response.data.data.list;

      if (me.listaForm.length > 0) {
        for (const form of me.listaForm) {
          me.sezioni = Array.from(new Set([...me.sezioni, form.sezione]));
        }
      }
    },
    callBackErrorList(error) {
      console.log("errorr");
      console.log(error);
    },
    onShownDynamicForm() {
      let defaultValues = { dataOra: new Date().getTime(), attenzione: null };
      this.$refs.cmpDynamicForm.setForm(defaultValues);
    },
    onClickConfermaForm() {
      let me = this;
      me.jsonDataBuilderSend = {
        jsonForm: JSON.stringify(me.jsonFormBuilder.jsonForm),
      };

      console.log(me.jsonDataBuilderSend);

      axios
        .post(process.env.VUE_APP_PATH_API + "/dynamicform", me.jsonDataBuilderSend)
        .then((response) => {
          console.log(response);
        })
        .catch((erro) => {
          console.log(erro);
        });
    },
    onChangeFormSelected() {
      let me = this;
      me.loadFormSchema();
    },
  },
  watch: {
    "jsonDataBuilderSend.titolo": function (params) {
      this.jsonFormBuilder.titolo = params;
    },
  },
};
</script>

<style>
.ft-scroll {
  border: 1px solid black;
  height: 600px;
  overflow: auto;
}
</style>
